<template>
<div class="flex flex-col flex-grow items-baseline">
    <label class="block mr-24 mb-8 first-letter:uppercase" for="">
        <slot name="title"></slot>
    </label>

    <div class="flex flex-wrap">
        <div class="mb-12">
            <slot name="header-toggle"></slot>
        </div>

        <div v-show="show"
            class="flex flex-wrap flex-grow justify-end items-baseline border border-primary-20 rounded w-full p-8">
            <simple-button
                v-if="studies.length > 3"
                small
                display="success"
                @click="addStudy"
                class="mb-8">
                <svg-icon type="add" class="max-w-16 max-h-16">
                </svg-icon>
            </simple-button>

            <div
                v-for="(study, index) in studies"
                :key="'study-selector-container-' + study.uuid"
                class="w-full mb-8 p-16 border border-primary-20 rounded bg-primary-5"
            >
                <div
                    v-if="studies.length > 1"
                    class="w-full flex justify-end -mt-4 mb-8">
                    <button class="text-primary-80 hover:text-primary-80 trans-ease -mr-8"
                        @click="removeStudy(index)">
                        <svg-icon type="cancel" class="max-w-16 max-h-16">
                        </svg-icon>
                    </button>
                </div>

                <study-selector
                    :topLvlStudies="topLvlStudies"
                    :value="study"
                    @input="selectStudy($event, index, study.uuid)"
                >
                </study-selector>
            </div>

            <simple-button small display="success" @click="addStudy">
                <svg-icon type="add" class="max-w-16 max-h-16">
                </svg-icon>
            </simple-button>
        </div>
    </div>
</div>
</template>

<script>
import * as vdab from '../../services/VdabService';
import SvgIcon from './SvgIcon.vue';
import SimpleButton from './SimpleButton.vue';
import StudySelector from './StudySelector.vue';
import shortid from 'shortid';

export default {
    components: {
        'svg-icon': SvgIcon,
        'simple-button': SimpleButton,
        'study-selector': StudySelector,
    },
    props: {
        value: {
            default () {
                return [{
                    id: null,
                }];
            },
            validator: value => Array.isArray(value),
        },
        show: {
            type: Boolean,
            default: true,
        }
    },
    data: function () {
        return {
            topLvlStudies: [],
        }
    },
    computed: {
        studies: {
            get () {
                return this.value;
            },
            set (value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        setTopLvlStudies () {
            vdab.indexStudies().then(
            result => {
                this.topLvlStudies = result.filter((study) => study.id !== 'A');
            });
        },
        selectStudy (study, index, uuid) {
            //remove all studies if selected study is "No study required"

            //empty study if selected study is null
            this.studies[index] = study ? Object.assign({uuid}, study) : { uuid, id: null };
        },
        addStudy () {
            this.studies.push({
                uuid: shortid.generate(),
                id: null,
            });
        },
        removeStudy (index) {
            this.studies.splice(index, 1);
        }
    },
    created () {
        this.setTopLvlStudies();
    },
}
</script>
